<template>


    <!-- screen type-->
    <tq-leaflet-edit
        class="TQ_height_bodyFullScreen_-40px TQ_padding_4px TQ_borderRadius TQ_box_shadow TQ_borderBox"

        :p_map-data_c="p_questBody_c.qb_mapData_c"
        :p_qb_riddles_ac="p_questBody_c.qb_mapMissions_ac"
        :p_mission-groups_ac="p_questBody_c.qb_mapMissionsGroup_ac"

        :p_display_lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"


        :p_qb_metadata_c="p_questBody_c.qb_metadata_c"
        :p_map-type_e="p_questBody_c.qb_metadata_c.qbm_mapMissions_mapType2_e"

        :pe_add-quest-body-riddle_c="(position_c, rectangleSize) => {p_questBody_c.cm_qb_addMapRiddle_f(position_c, rectangleSize)}"
        :pe_choose-image_f="pe_chooseImage_f"
    />



</template>

<script>


    import TqCard from "../../../../components/basic/TqCard";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqLeafletEdit from "../../../../components/maps/TqLeafletEdit";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqMoreInfo from "../../../../components/basic2/TqMoreInfo";
    import {FB_QuestBody} from "../../../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "C_Creator_EditQuests_Item_BodyMap",
        components:{
            TqMoreInfo,
            TqLeafletEdit,
            TqCard,
        },
        props:{
            p_questBody_c :{
                type    : FB_QuestBody,
                require : true,
            },
            p_system_langCode_e:{
                type: String,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                },
                require:true
            },
            pe_chooseImage_f : {
                type : Function,
                default: ()=>{}
            },
        },

    }
</script>

<style scoped lang="scss">

</style>
